module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-6-5c4544bf212af25e35eb0a8a4acc3fc8.webp";